var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5120"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 135",
    cx: 12.4993,
    cy: 12.4602,
    r: 12.4602,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7505 6H9.58284C7.33817 6 6 7.33817 6 9.58284V14.7505C6 16.9952 7.33817 18.3334 9.58284 18.3334H14.7505C16.9952 18.3334 18.3334 16.9952 18.3334 14.7505V9.58284C18.3334 7.33817 16.9952 6 14.7505 6ZM10.9148 13.955L9.52734 15.3425C9.43484 15.435 9.31768 15.4782 9.20051 15.4782C9.08334 15.4782 8.96001 15.435 8.87368 15.3425L8.41117 14.88C8.22617 14.7012 8.22617 14.4052 8.41117 14.2264C8.59001 14.0475 8.87984 14.0475 9.06484 14.2264L9.20051 14.362L10.2612 13.3014C10.44 13.1225 10.7298 13.1225 10.9148 13.3014C11.0937 13.4802 11.0937 13.7762 10.9148 13.955ZM10.9148 9.63835L9.52734 11.0258C9.43484 11.1184 9.31768 11.1615 9.20051 11.1615C9.08334 11.1615 8.96001 11.1184 8.87368 11.0258L8.41117 10.5633C8.22617 10.3845 8.22617 10.0885 8.41117 9.90968C8.59001 9.73085 8.87984 9.73085 9.06484 9.90968L9.20051 10.0453L10.2612 8.98468C10.44 8.80584 10.7298 8.80584 10.9148 8.98468C11.0937 9.16351 11.0937 9.45951 10.9148 9.63835ZM15.5954 15.0157H12.3579C12.105 15.0157 11.8954 14.806 11.8954 14.5532C11.8954 14.3004 12.105 14.0907 12.3579 14.0907H15.5954C15.8544 14.0907 16.0579 14.3004 16.0579 14.5532C16.0579 14.806 15.8544 15.0157 15.5954 15.0157ZM15.5954 10.699H12.3579C12.105 10.699 11.8954 10.4893 11.8954 10.2365C11.8954 9.98368 12.105 9.77401 12.3579 9.77401H15.5954C15.8544 9.77401 16.0579 9.98368 16.0579 10.2365C16.0579 10.4893 15.8544 10.699 15.5954 10.699Z",
    fill: "#545F65"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/Task.274b1decc0005103617ba710fe6e12ce.svg";
export { ForwardRef as ReactComponent };